export default "__VITE_ASSET__DZOWyeQn__"